import 'firebase/database';
import 'firebase/storage';
import 'firebase/auth';

import firebase from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyCf5PjAdV1kP4eS__COCa1fX5jit9Sm520",
  authDomain: "bayrakli-zeka-sorulari.firebaseapp.com",
  databaseURL: "https://bayrakli-zeka-sorulari-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "bayrakli-zeka-sorulari",
  storageBucket: "bayrakli-zeka-sorulari.appspot.com",
  messagingSenderId: "68139088568",
  appId: "1:68139088568:web:f1d964cc83fe1a5b48d24d",
  measurementId: "G-2QD2VQRPXX"
};

firebase.initializeApp(firebaseConfig);
export const firebaseDatabase = firebase.database();
export const firebaseStorage = firebase.storage();
export const firebaseAuth = firebase.auth();

